module.exports = __webpack_public_path__ + "static/media/institution-accent.7a66a0f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/institution-accent.svg
// module id = 174
// module chunks = 0